import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageNotificationService } from 'message-notification-service-lib';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Adv2Config } from '../components/adv2-config/adv2-config';

@Injectable({ providedIn: 'root' })
export class Adv2ConfigService {
  constructor(private http: HttpClient, private messageNotificationService: MessageNotificationService) {}

  getConfig(): Observable<Adv2Config> {
    const url = `${environment.kpHost}/adv2/config`;
    return this.http.get<Adv2Config>(url);
  }

  setConfig(config: Adv2Config): void {
    const url = `${environment.kpHost}/adv2/config`;
    this.http.put(url, config).subscribe(
      () => {
        this.messageNotificationService.success(`Settings successfully saved`);
      },
      (error) => {
        this.messageNotificationService.error(`An error occurred while saving settings`, error);
      }
    );
  }

  testCredentials(docusignCredentials: any): Observable<any> {
    const url = `${environment.kpHost}/adv2/config/testSignatureCredentials`;
    return this.http.post(url, docusignCredentials);
  }

  getConsentUrl(consentDetails: any): Observable<any> {
    const url = `${environment.kpHost}/adv2/config/signatureconsent`;
    return this.http.post(url, consentDetails);
  }
}
